"use client";

import React from "react";
import { Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DonChuyCuidamosALosQueMasQuieres() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222686" id="löydä-täydellinen-tila-tavaroillesi" className="relative overflow-hidden bg-background py-16 md:py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <div className="absolute -right-[10%] -top-[10%] h-[60%] w-[50%] rounded-lg bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-[10%] -left-[10%] h-[50%] w-[40%] rounded-lg bg-secondary/5 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 lg:col-span-7 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="space-y-4">
              <span className="inline-block rounded-lg bg-secondary/10 px-4 py-1.5 text-sm font-medium text-secondary font-default">Varastomikkeli – Edullista varastotilaa tilaa Mikkelistä</span>
              <h1 className="font-default text-4xl font-bold tracking-tight text-primary sm:text-5xl md:text-6xl lg:text-[4rem] lg:leading-[1.1]">
                Löydä täydellinen <span className="text-secondary">tila tavaroillesi</span>
              </h1>
            </div>
            
            <p className="max-w-2xl text-lg text-muted-foreground md:text-xl leading-relaxed font-default">Vuokraa varastotila Mikkelistä!<br />Tarjoamme moderneja ratkaisuja niin yksityisille kuin yrityksillekin kilpailukykyiseen hintaan ja helpolla varauksella.</p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-base rounded-lg bg-secondary text-secondary-foreground shadow-lg hover:shadow-xl hover:bg-secondary/90 transition-all">
                <Link to="/Varaa"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-calendar mr-2 h-5 w-5" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/DonChuyCuidamosALosQueMasQuieres.tsx|sig:6my9aq" data-ast-start="2539" data-ast-end="2576"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>Varaa&nbsp;</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative lg:col-span-5 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="relative mx-auto max-w-[400px] lg:max-w-none">
              {}
              <div className="relative aspect-[3/4] w-full overflow-hidden rounded-3xl shadow-2xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670724/img/modern_storage_facility_interior.png" alt="Moderni ja puhdas varastohalli kirkkaalla valaistuksella" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" src="https://live-sheep.10web.cloud/wp-content/uploads/2026/05/aarre.jpg" src="https://live-sheep.10web.cloud/wp-content/uploads/2026/06/IMG-20260526-WA0000.jpg" src="https://varastomikkeli.fi/wp-content/uploads/2026/06/IMG-20260526-WA0000.jpg" />
                {}
                <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-primary/10" />
              </div>

              {}
              
              
              {}
              <div className="absolute -right-6 -top-6 -z-10 h-32 w-32 bg-[radial-gradient(var(--color-secondary)_1px,transparent_1px)] [background-size:16px_16px] opacity-20" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}